





























































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { getDuration } from "@/hooks/useAttachmentFilesInfo";
import { isImageFile, isMediaFile } from "@/lib/fileHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseDuration from "@/components/BaseDuration/BaseDuration.vue";
import FullScreen from "@/components/FullScreen/FullScreen.vue";
import FullscreenArrow from "@/components/FullscreenArrow";
import GalleryTotalItems from "@/components/GalleryTotalItems/GalleryTotalItems.vue";
import MediaGalleryItem from "@/components/MediaGalleryItem";

export default defineComponent({
  name: "PurchaseGalleryItemFiles",
  components: {
    FullscreenArrow,
    BaseIcon,
    MediaGalleryItem,
    BaseDuration,
    GalleryTotalItems,
    FullScreen,
  },
  props: {
    files: { type: Array as PropType<FileData[]>, required: true },
  },
  setup(props) {
    const videoStarted = ref(false);
    const videoPlaying = ref(false);
    const currentVideoTime = ref(0);
    const itemIndex = ref(0);

    const scalable = computed(() => {
      return props.files[itemIndex.value] ? isImageFile(props.files[itemIndex.value]) : false;
    });

    const galleryItemStyle = computed(() => {
      const attachment = props.files.find(a => isMediaFile(a));
      const width = Number(attachment?.metadata.width ?? 0);
      const height = Number(attachment?.metadata.height ?? 0);

      if (width > 0 && height > 0) {
        const MAX_RATIO = 150;
        const MIN_RATIO = 45;
        const fileRatio = Math.ceil((height / width) * 100);

        return {
          "padding-bottom": `${Math.min(Math.max(fileRatio, MIN_RATIO), MAX_RATIO)}%`,
        };
      }
      return { "padding-bottom": "57%" };
    });

    const resetFile = () => {
      currentVideoTime.value = 0;
      videoStarted.value = false;
      videoPlaying.value = false;
    };

    return {
      videoPlaying,
      videoStarted,
      itemIndex,
      scalable,
      galleryItemStyle,
      currentVideoTime,
      resetFile,
      getDuration,
    };
  },
});
